export const getGeneralSurveyUrl = (): string =>
    'https://forms.microsoft.com/pages/responsepage.aspx?id=cgX2mhLfGkWYTjVGvineXab0XK69oApOko_TESRG4otUQkQwWkgwSzU5NVk5OFMyUzlFQlIyNEI1Uy4u';
